import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class ConnectionService {

  readonly token_key: string = 'token_key';

  authorizationTokenUpdated = new EventEmitter<string>();
  authorizationTokenExpired = new EventEmitter<any>();

  sendGetRequest(url: string, params?: any): Observable<ArrayBuffer> {
    return null;
  }

  sendMethodRequest(url: string, params?: any): Observable<any> {
    return null;
  }

  sendJsonPostRequest(url: string, params?: any): Observable<any> {
    return null;
  }

  sendFormPostRequest(url: string, formData?: FormData): Observable<any> {
    return of(null);
  }

  setAuthorizationToken(value: string, session: boolean) {
    if (session) {
      if(this.sessionAuthorizationToken !== value) {
        this.sessionAuthorizationToken = value;
        this.authorizationTokenUpdated.emit(value);
      }
    } else {
      if(this.localAuthorizationToken !== value) {
        this.localAuthorizationToken = value;
        this.authorizationTokenUpdated.emit(value);
      }
    }
  }

  clearAuthorizationToken() {
    this.localAuthorizationToken = null;
    this.sessionAuthorizationToken = null;
    this.authorizationTokenUpdated.emit();
  }

  get isAuthorizationTokenExist(): boolean {
    return this.authorizationToken != null && this.authorizationToken !== '';
  }

  get authorizationToken(): string {
    const token = this.sessionAuthorizationToken;
    if (token != null && token !== '') {
      return token;
    }

    return this.localAuthorizationToken;
  }

  private get localAuthorizationToken(): string {
    const token = this.sessionAuthorizationToken;
    if (token != null && token !== '') {
      return token;
    }

    return localStorage.getItem(this.token_key) || '';
  }

  private set localAuthorizationToken(token: string) {
    const previousToken = localStorage.getItem(this.token_key) || '';
    if (token === null || token === '') {
      localStorage.removeItem(this.token_key);
      if (previousToken) {
        this.authorizationTokenExpired.emit();
      }
      return;
    }

    localStorage.setItem(this.token_key, token);
  }

  private get sessionAuthorizationToken(): string {
    return sessionStorage.getItem(this.token_key) || '';
  }

  private set sessionAuthorizationToken(token: string) {
    if (token === null || token === '') {
      sessionStorage.removeItem(this.token_key);
      return;
    }

    sessionStorage.setItem(this.token_key, token);
  }
}
